// Hook do batch update ustawien panelu (kazdy element to {key, value, store_id?}).
// PUT /api/ui/core/panel/settings - body: { objects: [{ key, value, store_id }] }

import { axios } from 'api';
import { useMutation, UseMutationOptions } from 'react-query';
import { ICommandResponseError as IError, ICommandResponseSuccess } from 'api/types';

export interface IPutPanelSettingsObject {
  id?: number;
  key: string;
  value: string;
  store_id?: number | null;
}

export interface IPutPanelSettingsBody {
  objects: IPutPanelSettingsObject[];
}

type IResponse = ICommandResponseSuccess;

const putPanelSettings = (data: IPutPanelSettingsBody): Promise<IResponse> =>
  axios.put('/core/panel/settings', data);

export const usePutPanelSettings = (
  options?: UseMutationOptions<IResponse, IError, IPutPanelSettingsBody>
) => useMutation((data: IPutPanelSettingsBody) => putPanelSettings(data), options);
